import React from "react";
import { Button } from "@mantine/core";
import { useServerApi } from "../hooks/userServerApi";

import { useDisclosure } from "@mantine/hooks";

import { showNotification } from "@mantine/notifications";
import { IconCircleCheck, IconExclamationMark } from "@tabler/icons";
import ConfirmationModal from "./confirmationModal";
import { useTranslation } from "react-i18next";
import { useAuthUser } from "react-auth-kit";
import { useTabNavigate } from "../hooks/useTabNavigate";
import { getEntityTabLabel } from "../utils/tabNavigation";

const RenewalConfirmButton = ({ mainForm, disabled = false }) => {
  const [api] = useServerApi();
  const { _id: id, code, status } = mainForm.values;
  const [opened, { open, close }] = useDisclosure(false);
  const { t } = useTranslation();
  const auth = useAuthUser();
  const tabNav = useTabNavigate();
  const userRole = auth().userRole;
  const notAllowedStatus = status == "CONFIRM" || status == "TERMINATE";

  const debitNoteLink =
    userRole.entityLinks.find((l) => l.entity === "debitNote")?.link ??
    "/m/gi/debitNote";

  const openDebitNote = (dn) => {
    if (!dn?._id || !debitNoteLink) return;
    const label = getEntityTabLabel(dn, dn._id, "debitNote");
    if (tabNav.enabled) {
      tabNav.openDetail({
        pathname: debitNoteLink,
        id: dn._id,
        mode: "edit",
        label: dn.code || label,
      });
      return;
    }
    window.open(`${debitNoteLink}?id=${dn._id}&mode=edit`, "_blank");
  };

  const confirm = async () => {
    try {
      const result = await api.Renewal.confirm(id);
      close();

      if (result.success) {
        mainForm.setFieldValue("status", "CONFIRM");
        showNotification({
          title: `Renewal Confirmed`,
          color: "Green",
          icon: <IconCircleCheck size={18} />,
          message: "This renewal is confirmed.",
        });

        if (result.data?.DN) {
          openDebitNote(result.data.DN);
        }

        mainForm.notifyListRefresh?.();
        mainForm.reload();
      } else {
        throw result.error;
      }
    } catch (error) {
      showNotification({
        title: `Confirm Error`,
        color: "red",
        icon: <IconExclamationMark size={18} />,
        message: error,
      });
    }
  };

  return (
    <>
      <ConfirmationModal
        opened={opened}
        onClose={close}
        withCloseButton={false}
        size="lg"
        title={`Are you ready to confirm the renewal ${code}?`}
        confirmList={[
          "Please make sure the renewal details are correct and agreed by client.",
          " Debit Note will be created once confirmed.",
        ]}
        onConfirm={confirm}
      />

      <Button
        fullWidth
        color="green"
        onClick={open}
        disabled={disabled || !mainForm.values._id || notAllowedStatus}
      >
        {t("Confirm Renewal")}
      </Button>
    </>
  );
};

export default RenewalConfirmButton;
